export function VinylDisc({ title, artistName }: { title: string; artistName: string | null }) {
  return (
    <div className="media-disc absolute top-[2.5%] z-0 flex h-[95%] w-[95%] items-center justify-center rounded-full shadow-[0_10px_28px_rgba(0,0,0,0.55),0_0_0_1px_rgba(255,255,255,0.18)]">
      <div className="media-disc-rotor absolute inset-0 rounded-full flex items-center justify-center">
        {/* Base disc */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, #252729 0%, #151719 30%, #1b1d1f 52%, #111315 72%, #282b2e 96%, #151719 100%)",
          }}
        />
        {/* Outer edge bevel */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, transparent 90.5%, rgba(255,255,255,0.07) 93%, rgba(118,123,128,0.78) 96.5%, rgba(205,209,212,0.48) 98.5%, rgba(34,37,40,0.95) 100%)",
          }}
        />
        {/* Groove pattern - fine lines */}
        <div
          className="absolute inset-[4%] rounded-full"
          style={{
            background:
              "repeating-radial-gradient(circle at center, transparent 0px, transparent 1.5px, rgba(255,255,255,0.03) 1.8px, transparent 2.2px)",
          }}
        />
        {/* Groove pattern - wider bands */}
        <div
          className="absolute inset-[4%] rounded-full"
          style={{
            background:
              "repeating-radial-gradient(circle at center, transparent 0px, transparent 6px, rgba(255,255,255,0.015) 6.5px, transparent 8px)",
          }}
        />
        {/* Subtle concentric sheen keeps the record looking flat. */}
        <div
          className="absolute inset-[4%] rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, transparent 0%, transparent 44%, rgba(255,255,255,0.035) 44.5%, transparent 46%, transparent 63%, rgba(255,255,255,0.025) 64%, transparent 66%, transparent 100%)",
          }}
        />
        {/* Dead wax / run-out area */}
        <div
          className="absolute w-[38%] h-[38%] rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, transparent 60%, rgba(255,255,255,0.04) 65%, transparent 70%, rgba(255,255,255,0.02) 85%, transparent 90%)",
          }}
        />
        {/* A tiny run-out etching rotates with the disc without bending its surface. */}
        <div className="absolute left-[62%] top-[46%] h-[1px] w-[7%] rounded-full bg-white/20" />
        {/* Label */}
        <div
          className="absolute w-[32%] h-[32%] rounded-full flex items-center justify-center overflow-hidden"
          style={{
            background: "radial-gradient(circle at 40% 35%, #faf7ed 0%, #eee9dc 68%, #d8d1c2 100%)",
            boxShadow: "inset 0 1px 3px rgba(255,255,255,0.7), 0 0 0 2px rgba(0,0,0,0.8)",
          }}
        >
          {/* Label texture */}
          <div
            className="absolute inset-0 rounded-full opacity-30"
            style={{
              background:
                "repeating-radial-gradient(circle at center, transparent 0px, transparent 3px, rgba(0,0,0,0.1) 3.5px, transparent 4px)",
            }}
          />
          {/* Print spans the paper label, leaving the spindle hole between both lines. */}
          <div className="absolute inset-[6%] text-center text-black/85">
            {artistName && (
              <div className="absolute inset-x-0 top-[20%] truncate px-[4%] text-[clamp(5px,1.2vw,8px)] font-semibold uppercase leading-tight tracking-[0.12em]">
                {artistName}
              </div>
            )}
            <div className="absolute inset-x-0 bottom-[18%] truncate px-[3%] text-[clamp(6px,1.45vw,10px)] font-bold leading-tight">
              {title}
            </div>
          </div>
          {/* Offset print mark makes the otherwise circular label visibly rotate. */}
          <div className="absolute right-[18%] top-[22%] size-[5%] rounded-full bg-black/45" />
          {/* Spindle hole */}
          <div
            className="absolute w-[14%] h-[14%] rounded-full"
            style={{
              background: "radial-gradient(circle, #0a0a0a 60%, #222 80%, #0a0a0a 100%)",
              boxShadow: "inset 0 1px 2px rgba(255,255,255,0.1), 0 0 0 1px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      </div>
      {/* The room light stays fixed while the record turns underneath it. */}
      <div
        className="pointer-events-none absolute inset-[3%] rounded-full"
        style={{
          background:
            "conic-gradient(from 338deg at center, transparent 0deg 12deg, rgba(255,255,255,0.16) 30deg, rgba(255,255,255,0.025) 58deg, transparent 78deg 190deg, rgba(255,255,255,0.035) 215deg, rgba(255,255,255,0.18) 244deg, rgba(255,255,255,0.025) 274deg, transparent 300deg 360deg)",
          maskImage: "radial-gradient(circle, transparent 0 21%, black 23% 94%, transparent 99%)",
          WebkitMaskImage:
            "radial-gradient(circle, transparent 0 21%, black 23% 94%, transparent 99%)",
        }}
      />
    </div>
  );
}
